// @ts-nocheck
import { createAsyncAction } from '../../../core/store/actionCreators';
import {
  FETCH_SERVICE_MESSAGES,
  FETCH_PLATFORMS,
  CREATE_SERVICE_MESSAGE,
  UPDATE_SERVICE_MESSAGE,
} from './messageActionTypes';
import MessageService from '../services/MessageService';

export const fetchServiceMessages = createAsyncAction(FETCH_SERVICE_MESSAGES, async () => {
  const { data } = await MessageService.fetchServiceMessages();
  return data;
});

export const fetchPlatforms = createAsyncAction(FETCH_PLATFORMS, async () => {
  const { data } = await MessageService.fetchPlatforms();
  return data;
});

export const createServiceMessage = createAsyncAction(CREATE_SERVICE_MESSAGE, async messageData => {
  const { data } = await MessageService.createServiceMessage(messageData);
  return data;
});

export const updateServiceMessage = createAsyncAction(UPDATE_SERVICE_MESSAGE, async messageData => {
  const { data } = await MessageService.updateServiceMessage(messageData);
  return data;
});
